module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relay-table"
  }, [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.relays), function(relay, index) {
    return [_c('tr', {
      key: relay.id
    }, [_c('td', [_vm._v(_vm._s(relay.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(relay.field_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(relay.logical_no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(relay.scene_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(relay.function_name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [(relay.function_name != 'Momentary') ? _c('div', [_c('el-tag', {
      class: {
        on: relay.status == 'on'
      },
      attrs: {
        "type": "danger"
      }
    }, [_vm._v(_vm._s(relay.status))])], 1) : _c('div', [_c('el-tag', {
      attrs: {
        "type": "gray"
      }
    }, [_vm._v("See Attached Site")])], 1)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [(relay.function_name != 'Momentary') ? _c('div', [_c('el-button', {
      staticClass: "manual-on",
      attrs: {
        "type": "save"
      },
      on: {
        "click": function($event) {
          _vm.manual(relay.logical_no, 'on', index)
        }
      }
    }, [_vm._v("On")]), _vm._v(" "), _c('el-button', {
      staticClass: "manual-off",
      attrs: {
        "type": "cancel"
      },
      on: {
        "click": function($event) {
          _vm.manual(relay.logical_no, 'off', index)
        }
      }
    }, [_vm._v("Off")])], 1) : _c('div', [_c('el-button', {
      staticClass: "manual-on toggle",
      attrs: {
        "type": "save"
      },
      on: {
        "click": function($event) {
          _vm.manual(relay.logical_no, 'toggle', index)
        }
      }
    }, [_vm._v("Toggle")])], 1)])])]
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Field")]), _vm._v(" "), _c('th', [_vm._v("Logical/Port No")]), _vm._v(" "), _c('th', [_vm._v("Scene")]), _vm._v(" "), _c('th', [_vm._v("Function")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Override")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d40b0de","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Devices/RelayTable.vue
// module id = 316
// module chunks = 23